<div data-audience>
    <app-segmented-control
        [options]="modeOptions"
        [ngModel]="value.mode"
        (ngModelChange)="setMode($event)"
    ></app-segmented-control>

    <div class="aud-picker" [hidden]="!isSpecific">
        <div class="aud-grp-label">Teams</div>
        <label
            class="aud-opt"
            *ngFor="let t of teams"
            (click)="toggleTeam(t.id)"
        >
            <span class="checkbox" [class.checked]="isTeamChecked(t.id)">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg>
            </span>
            <div>
                <div class="aud-opt-name">{{ t.name }}</div>
                <div class="aud-opt-meta">{{ (t.memberIds || []).length }} members</div>
            </div>
        </label>

        <div class="aud-grp-label">Groups · custom</div>
        <label
            class="aud-opt"
            *ngFor="let g of groups"
            (click)="toggleGroup(g.id)"
        >
            <span class="checkbox" [class.checked]="isGroupChecked(g.id)">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg>
            </span>
            <div>
                <div class="aud-opt-name">{{ g.name }}</div>
                <div class="aud-opt-meta">{{ (g.memberIds || []).length }} members</div>
            </div>
        </label>

        <div
            class="aud-opt"
            *ngIf="!loading && teams.length === 0 && groups.length === 0"
            style="cursor: default"
        >
            <div class="aud-opt-meta">No teams or groups yet.</div>
        </div>
    </div>

    <div class="body-xs" style="color: var(--fg-muted); margin-top: 8px;">
        Manage teams &amp; groups in
        <a routerLink="/teams" style="color: var(--amber-d); font-weight: 600;">Teams</a>.
    </div>
</div>
